export default __webpack_public_path__ + "static/media/francheville28.3a7305b9.jpg";